module.exports = function() {
  return new Worker(__webpack_public_path__ + "37b43f14dfba599cc1f2.worker.js");
};